import React, { useCallback, useState, useRef, useEffect } from "react";
import MaterialReactTable from "material-react-table";
import { useDispatch } from "react-redux";
import { Button, Card, Container, Row, Col, Form, Spinner } from "react-bootstrap";
import { getListCommande, deleteCmd, ChangeEtatCmd, getCommentaireCmd, postSageCommande } from "../../Redux/commandeReduce";
import jwt_decode from "jwt-decode";
import { toast, ToastContainer } from "react-toastify";
import SweetAlert from "react-bootstrap-sweetalert";
import { getGrossisteSite } from "../../Redux/grossisteReduce";
import { useHistory } from "react-router-dom";
import { verification } from "../../Redux/usersReduce";
import { useTranslation } from 'react-multi-lang';
import { MRT_Localization_FR } from "material-react-table/locales/fr";
import { MRT_Localization_EN } from "material-react-table/locales/en";
import { useMemo } from "react";
import Configuration from "../../configuration";

function ListCommande({ obj, client }) {
  let lang = window.localStorage.getItem("lang");
  const t = useTranslation();
  const dispatch = useDispatch();
  const navigate = useHistory();
  const saveTableCalled = useRef(false);
  var token = localStorage.getItem("x-access-token");
  var annee = localStorage.getItem("annee");
  localStorage.removeItem("bonification");
  var decoded = jwt_decode(token);
  var idUser = decoded.id;
  const [loader, setLoader] = useState(true);
  const [data, setData] = useState([]);
  const [alert, setAlert] = useState(null);
  const [loading, setLoading] = useState(false);
  const [grossisteSite, setGrossisteSite] = useState({});

  const id_site = client == "/medis" ? 2 : 3;

  const dateLivraisonRef = useRef(null);
  const dateLivraisonAFCRef = useRef(null);
  const idRole = useRef(0);
  const commentaireRef = useRef(null);

  const setIdRole = (newValue) => {
    idRole.current = newValue;
  };
  // For dateLivraison
  const setDateLivraison = (newValue) => {
    dateLivraisonRef.current = newValue;
  };

  // For dateLivraisonAFC
  const setDateLivraisonAFC = (newValue) => {
    dateLivraisonAFCRef.current = newValue;
  };
  // For commentaire
  const setCommentaire = (newValue) => {
    commentaireRef.current = newValue;
  };

  const changeEtat = useCallback(async (idCmd) => {
    hideAlert();

    if (saveTableCalled.current) return;
    saveTableCalled.current = true
    var etat = idRole.current == 5 || idRole.current == 10 ? 2 : 1;
    setLoading(true);
    setLoader(true);
    if (idRole.current == 5 || idRole.current == 10) {
      dispatch(postSageCommande({ id_site, idCmd, etat: etat, date_livraison: dateLivraisonRef.current, commentaire: commentaireRef.current, date_livraison_afc: dateLivraisonAFCRef.current })).then(
        (e1) => {
          console.log(e1)

          if (e1.payload?.message == true) {
            saveTableCalled.current = false
            fectchListCommande(idUser, client)
            notify(1, t("add_txt"));
            setTimeout(async () => {
              navigate.push(client + "/commandeList");
            }, 500);
            setLoader(false);
            setLoading(false);
          }
          else {
            setLoader(false);
            setLoading(false);
            saveTableCalled.current = false
            notify(2, t("erreur"));
          }
        })
    } else {
      dispatch(ChangeEtatCmd({ id_site, idCmd, etat: 1, date_livraison: dateLivraisonRef.current, commentaire: commentaireRef.current, date_livraison_afc: dateLivraisonAFCRef.current })).then(
        (e1) => {
          if (e1.payload === true) {
            setLoading(false);
            setLoader(false);
            saveTableCalled.current = false
            fectchListCommande(idUser, client)
            setTimeout(async () => {
              window.location.reload()
            }, 500);
            notify(1, t("add_txt"));

          } else {
            setLoading(false);
            setLoading(false);
            saveTableCalled.current = false
            notify(2, t("erreur"));
          }
        }
      );
    }

  }, [loading]);

  const getCommentaire = async (idCmd) => {
    var commentaires = await dispatch(getCommentaireCmd({ idCmd }));

    var commentaireElements = commentaires.payload.map((element, index) => (
      (element.commentaire && element.commentaire !== "") ? (
        <li key={index}>
          <strong>{element.users.nom_prenom}</strong>: {element.commentaire} {new Date(element.createdAt).toISOString().split('T')[0]}
        </li>
      ) : null
    ));


    setAlert(
      <SweetAlert
        style={{ display: "block", marginTop: "-100px" }}
        onConfirm={() => hideAlert()}
        cancelBtnBsStyle="danger"
      >
        <h3 className="alert-title">{t("comment")}</h3>
        <ul>{(commentaireElements.length == 1 && (commentaireElements[0] == null || commentaireElements[0] == "")) || (commentaireElements.length == 2 && (commentaireElements[0] == null || commentaireElements[0] == "") && (commentaireElements[1] == null || commentaireElements[1] == "")) ? t("aucun_comment") : commentaireElements}</ul>
      </SweetAlert>
    );
  };


  const confirmMessageAccept = (idCmd, date_livraison) => {
    setAlert(
      <SweetAlert
        title=""
        style={{ display: "block", marginTop: "-100px" }}
        success
        onConfirm={() => confirmMessageDate(idCmd, date_livraison)}
        onCancel={() => hideAlert()}
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="danger"
        confirmBtnText={t("yes")}
        cancelBtnText={t("no")}
        showCancel
      >
        <h3 className="alert-title">{t("valider_commande")}</h3>
        {t("valider_commande_msg")}?
      </SweetAlert>
    );
  };

  const confirmMessageDate = useCallback((idCmd, date_livraison) => {
    if (date_livraison != null) setDateLivraison(date_livraison)
    setAlert(
      <SweetAlert
        style={{ display: "block", marginTop: "-100px" }}
        title=""
        onConfirm={() => handleConfirmDate(idCmd)}
        onCancel={() => hideAlert()}
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="danger"
        confirmBtnText={t("valider")}
        cancelBtnText={t("annuler")}
        showCancel
      >
        <h3 className="alert-title"> {idRole.current === 5 || idRole.current === 10 ? t("selectonnez_date_liv") : t("selectonnez_date_liv_souhaite")}</h3>
        <div>
          <Row>
            {idRole.current == 5 || idRole.current == 10 ?
              <Col md="6" className="pr-1">
                <Form.Group>
                  <label>{t('date_liv')} * </label>
                  <Form.Control
                    type="date"
                    min={new Date().toISOString().split('T')[0]}
                    className="form-control"
                    onChange={(e) => setDateLivraisonAFC(e.target.value)}
                  ></Form.Control>
                </Form.Group>
              </Col> : null}
            <Col md="6" className="pr-1">
              <Form.Group>
                <label>{t('date_liv_souhaite')} * </label>
                <Form.Control
                  value={date_livraison}
                  min={new Date().toISOString().split('T')[0]}
                  readOnly={idRole.current === 5 || idRole.current === 10 ? true : false}
                  type="date"
                  className="form-control"
                  onChange={(e) => setDateLivraison(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>

          <br></br>
          <Col md="12" className="pr-1">
            <Form.Group>
              <label>{t('commentaire')}  </label>
              <Form.Control
                as={"textarea"}
                className="form-control"
                placeholder={t('write_comment')}
                onChange={(e) => setCommentaire(e.target.value)}
                rows="5"
              ></Form.Control>
            </Form.Group>
          </Col>
        </div>
      </SweetAlert>
    );
  }, [t]);

  const handleConfirmDate = useCallback((idCmd) => {
    if ((idRole.current == 6 && !dateLivraisonRef.current) || (idRole.current == 5 && !dateLivraisonAFCRef.current) || (idRole.current == 10 && !dateLivraisonAFCRef.current)) {
      // Show an error toast or alert if the required fields are not filled
      notify(0, t("remplir_champs"));
      return;
    }

    changeEtat(idCmd);
  }, [loader]);



  const renderContentByType = (type) => {
    switch (type) {
      case 1:
        return t("order_list");
      case 2:
        return t("order_list_pdf");
      case 3:
        return t("order_list_excel");
      case 4:
        return t("order_initier");
      default:
        return null;
    }
  };

  function ListTable({ list, loader, loading, grossisteSite }) {

    const [columns] = useState([
      {
        id: "numero",
        header: t("num_order"),
        accessorKey: "numero",
      },
      {
        id: "date",
        header: t("date_cmd"),
        accessorKey: "date_commande",
        Cell: ({ cell }) => (
          <div className="block_action">
            {cell.row.original.date_commande !== null
              ? new Date(cell.row.original.date_commande)
                .toISOString()
                .slice(0, 10)
              : ""}
          </div>
        ),
      },
      {
        id: "montant_total",
        header: t("montant_total") + " HT",
        accessorKey: "Montant",
        Cell: ({ cell }) => (
          <div className="block_action">
            {new Intl.NumberFormat('fr-FR', {
              minimumFractionDigits: 3,
              maximumFractionDigits: 3
            }).format(cell.row.original.Montant.toFixed(3))}
          </div>
        ),
      },
      // {
      //   id: 'Site',
      //   header: "Industrie",
      //   accessorKey: "sites.nom",
      // },
      {
        id: "date_livraison",
        header: t("date_liv_souhaite"),
        accessorKey: "date_livraison",
        Cell: ({ cell }) => (
          <div className="block_action">
            {cell.row.original.date_livraison !== null
              ? new Date(cell.row.original.date_livraison)
                .toISOString()
                .slice(0, 10)
              : ""}
          </div>
        ),
      },
      {
        id: "validation",
        header: t("status"),
        accessorKey: "id",
        Cell: ({ cell }) => (
          (cell.row.original.etat == 0 && idRole.current == 6) || idRole.current == 5 ? t("Encours_grossiste") : t("Encours_afc")
        ),
      },
      {
        id: "type",
        header: t("Type commande"),
        accessorKey: "type",
      },
      {
        id: "type_insert",
        header: t("type_insert"),
        accessorKey: "type_insert",
        Cell: ({ cell }) => (
          <div className="block_action">
            {renderContentByType(cell.row.original.type_insert)}
          </div>
        ),
      },


      {
        id: "commentaire",
        header: t("commentaire"),
        accessorKey: "",
        Cell: ({ cell }) => (
          (cell.row.original.etat == 1) ? <Button
            id={"idLigne_" + cell.row.original.id}
            onClick={(e) => {
              getCommentaire(cell.row.original.id);
            }}

            title={t("commentaire")}
            className="btn-info btn "
          >
            <i className="fa fa-eye" />
          </Button> : null
        ),
      },
      {
        id: "visualization",
        header: t("visualization"),
        accessorKey: "id",
        Cell: ({ cell }) => (
          <Button
            id={"idLigne_" + cell.row.original.id}
            onClick={(e) => {
              detailCommande(cell.row.original.id);
              localStorage.setItem(
                "file",
                cell.row.original.namefile
              );
            }}
            title={t("details")}
            className="btn btn-info"
          >
            <i className="fas fa-info"></i>
          </Button>
        ),
      },
      {
        id: "action",
        header: "Action",
        accessorKey: "",
        Cell: ({ cell }) => {
          const showButtons = (cell.row.original.etat === 0 && idRole.current === 6) || idRole.current === 5 || idRole.current === 10;

          return (
            <div className="btn-cells">
              {loading ? (
                <div>
                  <Spinner
                    animation="border"
                    color="primary"
                    style={{ height: '2.5rem', width: '2.5rem' }}
                    type="grow"
                  />
                </div>
              ) : (
                showButtons && (
                  <>
                    {/* Bouton Valider */}
                    <Button
                      id={`idLigne_${cell.row.original.id}`}
                      onClick={() => {
                        confirmMessageAccept(cell.row.original.id, cell.row.original.date_livraison);
                      }}
                      variant="info"
                      className="btn btn-success mr-1"
                      title="Valider"
                    >
                      <i className="fa fa-check" />
                    </Button>

                    {/* Bouton Modifier */}
                    {((cell.row.original.type_commande === "CMD" && idRole.current === 6) || (idRole.current === 5 || idRole.current === 10)) && (
                      <Button
                        id={`idLigne_${cell.row.original.id}`}
                        onClick={() => {
                          editCommande(cell.row.original.id);
                          localStorage.setItem("file", cell.row.original.namefile);
                        }}
                        variant="warning"
                        className="btn btn-warning mr-1"
                        title="Modifier"
                      >
                        <i className="fa fa-edit" />
                      </Button>
                    )}
                    {/* Bouton Supprimer */}
                    {cell.row.original.etat === 0 && idRole.current === 6 && (
                      <Button
                        id={`idLigne_${cell.row.original.id}`}
                        onClick={() => {
                          confirmMessageDelete(cell.row.original.id);
                        }}
                        variant="danger"
                        className="btn btn-danger mr-1"
                        title="Supprimer"
                      >
                        <i className="fa fa-trash" />
                      </Button>
                    )}
                  </>
                )

              )}
            </div>
          );
        }
      },
      // {
      //   id: "telecharger",
      //   header: t("telecharger_pdf"),
      //   accessorKey: "",
      //   Cell: ({ cell }) => (
      //     <ImprimerCmd t={t} idCmd={cell.row.original.id} type={1} client={client} />
      //   ),
      // },
    ]);



    const columnsAfc = useMemo(() => [
      {
        id: "numero",
        header: t("num_order"),
        accessorKey: "numero",
      },
      {
        id: "grossiste",
        header: "Code " + t("Wholesaler"),
        accessorKey: "grossistes.Code_client",
        Cell: ({ cell }) => (
          <div>{grossisteSite[cell.row.original.id_grossiste]}</div>
        ),
      },
      {
        id: "grossiste",
        header: t("Wholesaler"),
        accessorKey: "grossistes.Raison_sociale",
      },
      {
        id: "date",
        header: t("date_cmd"),
        accessorKey: "date_commande",
        Cell: ({ cell }) => (
          <div className="block_action">
            {cell.row.original.date_commande !== null
              ? new Date(cell.row.original.date_commande)
                .toISOString()
                .slice(0, 10)
              : ""}
          </div>
        ),
      },
      {
        id: "montant_total",
        header: t("montant_total") + " HT",
        accessorKey: "Montant",
        Cell: ({ cell }) => (
          <div className="block_action">
            {new Intl.NumberFormat('fr-FR', {
              minimumFractionDigits: 3,
              maximumFractionDigits: 3
            }).format(cell.row.original.Montant.toFixed(3))}
          </div>
        ),
      },
      //  {
      //   id: 'Site',
      //   header: "Industrie",
      //   accessorKey: "sites.nom",
      // },
      {
        id: "date_livraison",
        header: t("date_liv_souhaite"),
        accessorKey: "date_livraison",
        Cell: ({ cell }) => (
          <div className="block_action">
            {cell.row.original.date_livraison !== null
              ? new Date(cell.row.original.date_livraison)
                .toISOString()
                .slice(0, 10)
              : ""}
          </div>
        ),
      },
      {
        id: "validation",
        header: t("status"),
        accessorKey: "id",
        Cell: ({ cell }) => (
          cell.row.original.etat == 1 ? t("Encours_afc") : t("Encours_grossiste")
        ),
      },
      {
        id: "type",
        header: t("Type commande"),
        accessorKey: "type",
      },
      {
        id: "type_insert",
        header: t("type_insert"),
        accessorKey: "type_insert",
        Cell: ({ cell }) => (
          <div className="block_action">
            {renderContentByType(cell.row.original.type_insert)}
          </div>
        ),
      },

      {
        id: "commentaire",
        header: t("commentaire"),
        accessorKey: "",
        Cell: ({ cell }) => (
          (cell.row.original.etat == 1) ? <Button
            id={"idLigne_" + cell.row.original.id}
            onClick={(e) => {
              getCommentaire(cell.row.original.id);
            }}
            title={t("commentaire")}
            className="btn-info btn "
          >
            <i className="fa fa-info" />
          </Button> : null
        ),
      },
      {
        id: "visualization",
        header: t("visualization"),
        accessorKey: "id",
        Cell: ({ cell }) => (
          <Button
            id={"idLigne_" + cell.row.original.id}
            onClick={(e) => {
              detailCommande(cell.row.original.id);
              localStorage.setItem(
                "file",
                cell.row.original.namefile
              );
            }}
            className="btn btn-info"
          >
            <i className="fas fa-eye"></i>
          </Button>
        ),
      },
      {
        id: "action",
        header: "Action",
        accessorKey: "",
        Cell: ({ cell }) => (
          loading ? (
            <div className="">
              <Spinner animation="border" color="primary" style={{ height: '2.5rem', width: '2.5rem' }} type="grow" />
            </div>
          ) : (
            <div className="btn-cells">
              {(cell.row.original.etat === 0 && idRole.current === 6) || idRole.current === 5 || idRole.current === 10 ? (
                <Button
                  id={`idLigne_${cell.row.original.id}`}
                  onClick={() => {
                    confirmMessageAccept(cell.row.original.id, cell.row.original.date_livraison);
                  }}
                  variant="info"
                  className="btn btn-success success mr-1"
                  title="Valider"
                  disabled={loading} // Disable while loading
                >
                  <i className="fa fa-check" />
                </Button>
              ) : null}

              {(cell.row.original.etat === 0 && idRole.current === 6) || idRole.current === 5 || idRole.current === 10 ? (
                <>
                  <Button
                    id={`idLigne_${cell.row.id}`}
                    onClick={() => {
                      editCommande(cell.row.original.id);
                      localStorage.setItem("file", cell.row.original.namefile);
                    }}
                    variant="warning"
                    className="btn-warning btn mr-1"
                    title="Modifier"
                    disabled={loading} // Disable while loading
                  >
                    <i className="fa fa-edit" />
                  </Button>
                  {(cell.row.original.etat == 1 && idRole.current == 5) ? (
                    <Button
                      id={`idLigne_${cell.row.id}`}
                      onClick={() => {
                        confirmMessageDelete(cell.row.original.id);
                      }}
                      variant="danger"
                      className="btn-danger btn mr-1"
                      title="Supprimer"
                      disabled={loading} // Disable while loading
                    >
                      <i className="fa fa-trash" />
                    </Button>
                  ) : null}
                </>
              ) : null}
            </div>
          )
        ),
      },
      // {
      //   id: "telecharger",
      //   header: t("telecharger_pdf"),
      //   accessorKey: "",
      //   Cell: ({ cell }) => (
      //     <ImprimerCmd t={t} idCmd={cell.row.original.id} type={1} client={client} />
      //   ),
      // },

    ], [grossisteSite, t]);

    return (
      idRole.current != 6 ? <MaterialReactTable
        state={{ isLoading: loader }}
        columns={columnsAfc}
        data={list}
        enableColumnActions={true}
        enableColumnFilters={true}
        enablePagination={true}
        enableSorting={true}
        enableBottomToolbar={true}
        enableTopToolbar={true}
        muiTableBodyRowProps={{ hover: false }}
        displayColumnDefOptions={{
          'mrt-row-numbers': {
            size: 10,
          },
          'mrt-row-expand': {
            size: 10,
          },
        }}
        enableColumnFilterModes
        initialState={{
          columnVisibility: { description: false },
          density: 'compact',
          showGlobalFilter: true,
        }} muiSearchTextFieldProps={{
          placeholder: t("search"),
          sx: { minWidth: '18rem' },
          variant: 'outlined',
        }}
        localization={
          lang === "fr"
            ? MRT_Localization_FR
            : MRT_Localization_EN
        }
      /> : <MaterialReactTable
        state={{ isLoading: loader }}
        columns={columns}
        data={list}
        enableColumnActions={true}
        enableColumnFilters={true}
        enablePagination={true}
        enableSorting={true}
        enableBottomToolbar={true}
        enableTopToolbar={true}
        muiTableBodyRowProps={{ hover: false }}
        displayColumnDefOptions={{
          'mrt-row-numbers': {
            size: 10,
          },
          'mrt-row-expand': {
            size: 10,
          },
        }}
        enableColumnFilterModes
        initialState={{
          columnVisibility: { description: false },
          density: 'compact',
          showGlobalFilter: true,
        }}
        muiSearchTextFieldProps={{
          placeholder: t("search"),
          sx: { minWidth: '18rem' },
          variant: 'outlined',
        }}

        filterFns={{
          myCustomFilterFn: (row, id, filterValue) => {
            const value = row.getValue(id);
            return typeof value === 'string' && value.toLowerCase().includes(filterValue.toLowerCase());
          },
        }}
        globalFilterFn="myCustomFilterFn"

        localization={
          lang === "fr"
            ? MRT_Localization_FR
            : MRT_Localization_EN
        }
      />
    );

  }
  const verifToken = useCallback(async () => {
    var response = await dispatch(verification());
    if (response.payload === false) {
      localStorage.clear();
      window.location.replace("/login");
    } else {
      setIdRole(response.payload.id_role)
    }
  }, [dispatch]);


  const notify = (type, msg) => {
    if (type === 1)
      toast.success(<strong>{msg}</strong>);
    else
      toast.error(<strong>{msg}</strong>);
  }

  const deleteCmdA = useCallback(
    async (id) => {
      setLoading(true)
      dispatch(
        deleteCmd(id)
      ).then(e => {
        hideAlert()
        setLoading(false)
        fectchListCommande(idUser, client)
        notify(1, t("supprimer_succes"));
      })
    },
    [dispatch

    ]
  );

  const confirmMessageDelete = (id, nb) => {
    setAlert(
      <SweetAlert
        style={{ display: "block", marginTop: "-100px" }}
        title={t("Commande.supprimer")}
        onConfirm={() => deleteCmdA(id)}
        onCancel={() => hideAlert()}
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="danger"
        confirmBtnText={t("yes")}
        cancelBtnText={t("no")}
        showCancel
      >
      </SweetAlert>
    );
  };

  const hideAlert = () => {
    setAlert(null);
  };

  const fectchListCommande = useCallback(
    async (idUser, client) => {
      var etat = idRole.current == 5 || idRole.current == 10 ? [1] : [0, 1];
      var list = await dispatch(
        getListCommande({
          id_user: idUser,
          etat,
          annee, client
        })
      );
      var res = list.payload;

      setLoader(false);
      setData(res);
    },
    [dispatch, loader]
  );


  function detailCommande(idCmd) {
    navigate.push(client + "/detailsCmd/" + idCmd);
  }

  function editCommande(idCmd) {
    navigate.push(client + "/updateCmd/" + idCmd);
  }

  function handleGrossisteSite(client) {
    dispatch(getGrossisteSite({ id_site: client == Configuration.industrie2 ? 2 : 3 })).then((e) => {
      setGrossisteSite(e.payload)
    });

  }

  React.useEffect(() => {
    const fetchData = async () => {
      await verifToken();
      if (idRole.current > 0) {
        fectchListCommande(idUser, client);
       if(obj.user.id_role != 6 ) handleGrossisteSite(client)
      }
    };

    fetchData();
  }, [idRole.current, loading, loader]);

  const [socket, setSocket] = useState(null);

  useEffect(() => {
    if (obj.user.id_role !== 6) {
      const ws = new WebSocket(`wss://orders.labomedis.com/`);
      ws.onerror = (error) => console.error('WebSocket Error:', error);
      ws.onclose = (event) => console.log('WebSocket Closed:', event);
      setSocket(ws);
      console.log(ws)
      ws.onopen = () => {
        console.log("WebSocket connected.");
      };


      ws.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          console.log("WebSocket message received:", data);
          console.log(data.action)
          if (data.action === "postSage") {
            setLoading(true);
          }

          if (data.action === "endpostSage") {
            setLoading(false);
            fectchListCommande(idUser, client)
          }

        } catch (error) {
          console.error("Error handling WebSocket message:", error);
        }
      };

      ws.onerror = (error) => {
        console.error("WebSocket error:", error);
      };

      ws.onclose = () => {
        console.log("WebSocket disconnected.");
      };

      return () => {
        ws.close();
      };
    }
  }, []);

  return (
    <>
      {alert}
      <Container fluid>
        <ToastContainer />
        <Row>
          <Col md="12">
            <Card>
              <Card.Header>
                <Card.Title as="h4">{t("orders_pending")}</Card.Title>
              </Card.Header>
              <Card.Body className="table-style">
                <ListTable list={data} loader={loader} loading={loading} grossisteSite={grossisteSite} ></ListTable>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default ListCommande;
